import { ROUTES } from '@/utils/constants';
import { Link } from 'react-router-dom';

export function LandingNav() {
  return (
    <nav className="landing-nav">
      <div className="landing-wide landing-nav__inner">
        <Link className="landing-nav__wordmark" to={ROUTES.HOME}>
          <img
            className="nav-logo-mark"
            src="/brand/logo-n-ribbon.svg"
            alt="N"
          />
          <span className="nav-wordmark-text">ESTRA</span>
        </Link>
        <div className="landing-nav__right">
          <Link to={ROUTES.LOGIN} className="landing-nav__signin">
            Log in
          </Link>
          <Link to={ROUTES.SIGNUP} className="landing-btn landing-btn--coral">
            Sign up free
          </Link>
        </div>
      </div>
    </nav>
  );
}
